import timingMath from "src/utils/timing-math";

const resourceXhrs = new Set<HBRequestInfo>();
const MAX_CLEARTIME = 2 * 60 * 1000;

let perforEntrys: PerformanceResourceTiming[] = [];

let timer = null;
// 清除数据队列中已经匹配的数据和已经过期的数据
function trimEntrys(entryName?: string) {
  if(timer) {
    clearTimeout(timer);
    timer = null;
  }
  if(entryName) {
    resourceXhrs.forEach(item => {
      if(item.rtiming.name === entryName) {
        resourceXhrs.delete(item);
      }
    });
  }
  timer = setTimeout(() => {
    timer = null;
    const pnew = performance.now();

    // 清除resourceXhrs中过期的数据
    resourceXhrs.forEach((value) => {
      const pst = value.rtiming.startTime as number;
      const d = value.rtiming.duration as number;
      if (pnew - (pst + d) > MAX_CLEARTIME) {
        resourceXhrs.delete(value);
      }
    });

    // 清除perforEntrys中过期的数据和已经匹配过的数据
    if(performance.getEntries().length > 230) {
      const curResourceEntrys = performance.getEntriesByType('resource')
        .filter(item => item.initiatorType === 'xmlhttprequest' || item.initiatorType === 'fetch');
      perforEntrys.push(...curResourceEntrys);
      performance.clearResourceTimings();
    }
    const newEntrys = perforEntrys.filter(item => {
      // @ts-ignore
      if (!item.isMatched && pnew - (item.startTime + item.duration) < MAX_CLEARTIME) {
        return true
      }
      return false;
    });
    // hbLogger.debug('trimEntrys:', perforEntrys.length, newEntrys.length, newEntrys);
    perforEntrys = newEntrys;
  }, 1000);
}

function formatUrl(url: string) {
  // 通过URL对地址进行规范化，如空格、中文字符转义、443端口问题等，以便与PerformanceResourceTiming.name进行匹配
  try {
    return url.startsWith('http') ? new URL(url).toString() : new URL(`http://a.cn/${url}`).toString().substring(12);
  } catch (error) {
    hbLogger.warn(`Invalid URL: ${url}`, error);
    return url;
  }
}

function matchUrl(purl: string, xurl: string) {
  if (xurl.endsWith('...')) {
    return purl.includes(xurl.replace(/\.\.\.$/, ''));
  } else {
    return purl.endsWith(xurl);
  }
}

// performance异步监听方式获取数据的匹配实现模式
function findSame(evt: HBEventData) {
  if(!evt || !evt.rurl) {
    return null;
  }
  let ret = null;
  const evtStartTime = evt._relativeTimeStart as number;
  const rurl = formatUrl(evt.rurl);
  let result: { difv: number; xhr: HBRequestInfo } = null;
  resourceXhrs.forEach((value) => {
    const pst = value.rtiming.startTime as number;
    if (matchUrl(value.rurl, rurl)) {
      const difv = Math.abs(evtStartTime - pst);
      if(!result || difv < result.difv) {
        result = {
          difv,
          xhr: value
        };
      }
    }
  });
  if(result && result.xhr) {
    resourceXhrs.delete(result.xhr);
    ret = { rtiming: { ...result.xhr.rtiming, matchType: 1 } };
  }
  return ret;
}
// performance同步获取数据的匹配实现模式
function findSame2(evt: HBEventData) {
  if(!evt || !evt.rurl) {
    return null;
  }
  let ret = null;
  const evtStartTime = evt._relativeTimeStart as number;
  const rurl = formatUrl(evt.rurl);
  const curResourceEntrys = performance.getEntriesByType('resource')
    .filter(item => item.initiatorType === 'xmlhttprequest' || item.initiatorType === 'fetch');
  const findEntrys = perforEntrys.concat(curResourceEntrys).filter(item => {
    // @ts-ignore
    const isMatched = item.isMatched;
    return !isMatched && matchUrl(item.name, rurl);
  });

  let result: { difv: number; xhr: PerformanceResourceTiming } = null;
  findEntrys.forEach((value) => {
    const pst = value.startTime;
    const difv = Math.abs(evtStartTime - pst);
    if(!result || difv < result.difv) {
      result = {
        difv,
        xhr: value
      };
    }
  });
  if(result && result.xhr) {
    const { cacheType } = timingMath(result.xhr);
    const rtiming = result.xhr.toJSON();
    rtiming.matchType = 2;
    rtiming.cacheType = cacheType;
    // @ts-ignore
    result.xhr.isMatched = true;
    ret = { rtiming };
  }
  trimEntrys(result?.xhr?.name);
  return ret;
}

export default {
  push(evt: HBRequestInfo) {
    resourceXhrs.add(evt);
  },
  findSame: (evt: HBEventData) => findSame2(evt) || findSame(evt),
};
